import React, { Component } from 'react';
import './ProgressBar.scss';

class ProgressBar extends Component {
	constructor(props) {
		super(props);

		this.sampleRef = React.createRef();

		this.state = {
			sampleWidth: 0,
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.text !== this.props.text) {
			this.setState({
				sampleWidth: this.sampleRef.current ? this.sampleRef.current.clientWidth : 0,
			});
		}
	}

	render() {
		let percent = parseInt(this.state.sampleWidth) / parseInt(this.props.maxLength) * 100;
		let style = {
			width: `${percent}%`,
		}

		let fillClass = 'fill';
		let textLength = this.props.text.length || 0;

		let {minTextLength, maxTextLength, optimalMinTextLength, maxLength} = this.props;

		if (textLength >= minTextLength && this.state.sampleWidth <= maxLength) {
			if ((textLength >= minTextLength && textLength < optimalMinTextLength) || (textLength > maxTextLength && this.state.sampleWidth <= maxLength)) {
				fillClass += ' medium';
			} else if (textLength >= optimalMinTextLength && textLength <= maxTextLength) {
				fillClass += ' ok';
			}
		}

		return (
			<div className="progress-bar">
				<div className="text-sample" ref={this.sampleRef} style={{fontSize: `${this.props.sampleFontSize || 16}px`}}>{this.props.text}</div>
				<div className="progress-bar-info">{this.props.labelPrefix || ''}Width: {this.state.sampleWidth}px, Characters: {this.props.text.length}</div>
				<div className="bar">
					<div className={fillClass} style={style}></div>
				</div>
			</div>
		)
	}
}

export default ProgressBar;